import { DvaReducer } from '@/models/shared';
import { AnyAction } from 'redux';
import { EffectsCommandMap, Subscription } from 'dva';
import { CollectionDetailPageModelState, ConnectState } from '@/models/connect';
import fMessage from '@/components/fMessage';
import { FUtil, FServiceAPI, FI18n } from '@freelog/tools-lib';
import { history, UpdateRewriteParams } from 'umi';
import { PolicyFullInfo_Type } from '@/type/contractTypes';
// import FComponentsLib from '@freelog/components-lib';
import fPromiseModalConfirm from '@/components/fPromiseModalConfirm';
import moment from 'moment';
import { fSetHotspotTooltipVisible } from '@/components/FHotspotTooltip';
import { updateRewrite } from './exhibitInfoPage';
export interface CollectionExhibitInfoPageModelState {
  pageLoading: boolean;

  exhibit_ID: string;
  exhibit_Name: string;
  exhibit_Title: string;
  exhibit_Online: boolean;
  exhibit_IsAuth: boolean;
  exhibit_AuthErrorText: string;
  exhibit_BelongNode_ID: number;
  exhibit_BelongNode_Name: string;
  exhibit_BelongNode_Title: string;
  exhibit_BelongNode_ActiveThemeId: string;

  exhibit_Cover: string;

  exhibit_ResourceInfo: {
    id: string;
    cover: string;
    name: string;
    title: string;
    version: string;
    policy: string[];
    type: string[];
    status: 0 | 1 | 2 | 4;
    authProblem?: boolean;
    updateDate: string;
    username: string;
    useAvatar: string;
    isChoice: boolean;
    collection?: {
      status: 'finish' | 'unFinish';
      count: number;
    } | null;
  } | null;

  policy_List: PolicyFullInfo_Type[];

  graphShow: boolean;

  side_ExhibitTitle: string;
  side_ExhibitIntroduction: string;
  side_ExhibitTags: string[];
  side_AllVersions: string[];
  side_Version: string;
  side_SettingUnfold: boolean;
  side_RawProperties: {
    key: string;
    name: string;
    value: string;
    description: string;
  }[];
  side_BaseProperties: {
    key: string;
    name: string;
    value: string;
    description: string;
  }[];
  // side_InheritOptions: {
  //   key: string;
  //   name: string;
  //   value: string;
  //   description: string;
  //   type: 'input' | 'select';
  //   options: string[];
  //   resetValue: string;
  //   valueInput: string;
  //   valueInputError: string;
  // }[];
  inheritOptions: {
    key: string;
    name: string;
    value: string;
    description: string;
    type: 'input' | 'select';
    options: string[];
    defaultValue: string;
  }[];
  customOptions: {
    key: string;
    name: string;
    value: string;
    description: string;
  }[];

  collectionItemsSetting: {
    // collection_sorting: 'collection_sort_newest'
    //   | 'collection_sort_oldest'
    //   | 'collection_sort_title'
    //   | 'collection_sort_title_reverse'
    //   | 'collection_sort_manual'
    //   | 'collection_sort_manual_reverse';
    collection_sort_list:
      | 'collection_sort_ascending'
      | 'collection_sort_descending';
    collection_item_title:
      | 'collection_item_title_rtitle'
      | 'collection_item_title_sn'
      | 'collection_item_title_empty'
      | 'collection_item_title_custom';
    collection_item_no_display:
      | 'collection_item_no_display_show'
      | 'collection_item_no_display_hide';
    collection_item_image_display:
      | 'collection_item_image_display_show'
      | 'collection_item_image_display_hide';
    collection_item_descr_display:
      | 'collection_item_descr_display_show'
      | 'collection_item_descr_display_hide';
    collection_view: 'collection_view_list' | 'collection_view_card';
  };
  collectionItems_keywords: string;
  collectionItems: {
    itemID: string;
    itemTitle: string;
    itemSerial: number;
    itemNumber: string;
    resourceInfo: {
      id: string;
      cover: string;
      name: string;
      title: string;
      version: string;
      policy: string[];
      type: string[];
      status: 0 | 1 | 2 | 4;
      authProblem: boolean;
      updateDate: string;
      username: string;
      useAvatar: string;
      isChoice: boolean;
      intro: string;
      releaseDateTime?: string;
    };
  }[];
  collectionItems_totalCount: number;
  collectionItems_pageCurrent: number;
  collectionItems_pageSize: number;
  collectionItems_inited: boolean;
}

export interface ChangeAction extends AnyAction {
  type: 'change' | 'collectionExhibitInfoPage/change';
  payload: Partial<CollectionExhibitInfoPageModelState>;
}

export interface OnMountPageAction extends AnyAction {
  type: 'collectionExhibitInfoPage/onMountPage';
  payload: {
    exhibitID: string;
  };
}

export interface OnUnmountPageAction extends AnyAction {
  type: 'collectionExhibitInfoPage/onUnmountPage';
}

export interface FetchInfoAction extends AnyAction {
  type: 'fetchInfo' | 'collectionExhibitInfoPage/fetchInfo';
}

export interface Fetch_CollectionItems_Action extends AnyAction {
  type:
    | 'fetch_CollectionItems'
    | 'collectionExhibitInfoPage/fetch_CollectionItems';
}

export interface AddAPolicyAction extends AnyAction {
  type: 'collectionExhibitInfoPage/addAPolicy';
  payload: {
    title: string;
    text: string;
  };
}

export interface UpdateAPolicyAction extends AnyAction {
  type: 'collectionExhibitInfoPage/updateAPolicy';
  payload: {
    id: string;
    status: 0 | 1;
  };
}

export interface UpdateBaseInfoAction extends AnyAction {
  type: 'collectionExhibitInfoPage/updateBaseInfo';
  payload: Partial<
    Pick<
      CollectionExhibitInfoPageModelState,
      'exhibit_Cover' | 'side_ExhibitTitle' | 'side_ExhibitTags'
    >
  >;
}

export interface UpdateStatusAction extends AnyAction {
  type: 'collectionExhibitInfoPage/updateStatus';
  payload: 0 | 1;
}

export interface UpdateRewriteAction extends AnyAction {
  type: 'collectionExhibitInfoPage/updateRewrite' | 'updateRewrite';
}

export interface ChangeVersionAction extends AnyAction {
  type: 'collectionExhibitInfoPage/changeVersion';
  payload: string;
}

export interface OnSave_Side_ExhibitIntroduction_Action extends AnyAction {
  type: 'collectionExhibitInfoPage/onSave_Side_ExhibitIntroduction';
  payload: {
    value: string;
  };
}

// export interface OnClick_Side_InheritOptions_ResetBtn_Action extends AnyAction {
//   type: 'collectionExhibitInfoPage/onClick_Side_InheritOptions_ResetBtn';
//   payload: {
//     index: number;
//   };
// }

// export interface OnChange_Side_InheritOptions_ValueInput_Action extends AnyAction {
//   type: 'collectionExhibitInfoPage/onChange_Side_InheritOptions_ValueInput';
//   payload: {
//     index: number;
//     value: string;
//   };
// }

// export interface OnBlur_Side_InheritOptions_ValueInput_Action extends AnyAction {
//   type: 'collectionExhibitInfoPage/onBlur_Side_InheritOptions_ValueInput';
//   payload: {
//     index: number;
//   };
// }

// export interface OnBlur_Side_InheritOptions_ValueInput_Action extends AnyAction {
//   type: 'collectionExhibitInfoPage/onBlur_Side_InheritOptions_ValueInput';
//   payload: {
//     index: number;
//   };
// }

export interface OnSync_Options_Action extends AnyAction {
  type: 'collectionExhibitInfoPage/onSync_Options';
  payload?: {
    successMessage?: string;
  };
}

export interface OnClick_Side_CustomOptions_DeleteBtn_Action extends AnyAction {
  type: 'collectionExhibitInfoPage/onClick_Side_CustomOptions_DeleteBtn';
  payload: {
    index: number;
  };
}

export interface OnChange_Side_CustomOptions_ValueInput_Action
  extends AnyAction {
  type: 'collectionExhibitInfoPage/onChange_Side_CustomOptions_ValueInput';
  payload: {
    index: number;
    value: string;
  };
}

export interface OnBlur_Side_CustomOptions_ValueInput_Action extends AnyAction {
  type: 'collectionExhibitInfoPage/onBlur_Side_CustomOptions_ValueInput';
  payload: {
    index: number;
  };
}

export interface OnConfirm_AddCustomOptionsDrawer_Action extends AnyAction {
  type: 'collectionExhibitInfoPage/onConfirm_AddCustomOptionsDrawer';
  payload: {
    value: {
      key: string;
      name: string;
      // type: 'input' | 'select';
      input: string;
      // select: string[];
      description: string;
    };
  };
}

export interface OnConfirm_CustomOptionDrawer_Action extends AnyAction {
  type: 'collectionExhibitInfoPage/onConfirm_CustomOptionDrawer';
  payload: {
    value: {
      key: string;
      name: string;
      value: string;
      description: string;
      valueType: 'input' | 'select';
    };
  };
}

// export interface OnCancel_CustomOptionDrawer_Action extends AnyAction {
//   type: 'collectionExhibitInfoPage/onCancel_CustomOptionDrawer';
// }

export interface CollectionExhibitInfoPageModelType {
  namespace: 'collectionExhibitInfoPage';
  state: CollectionExhibitInfoPageModelState;
  effects: {
    onMountPage: (
      action: OnMountPageAction,
      effects: EffectsCommandMap,
    ) => void;
    onUnmountPage: (
      action: OnUnmountPageAction,
      effects: EffectsCommandMap,
    ) => void;
    fetchInfo: (action: FetchInfoAction, effects: EffectsCommandMap) => void;
    fetch_CollectionItems: (
      action: Fetch_CollectionItems_Action,
      effects: EffectsCommandMap,
    ) => void;
    addAPolicy: (action: AddAPolicyAction, effects: EffectsCommandMap) => void;
    updateAPolicy: (
      action: UpdateAPolicyAction,
      effects: EffectsCommandMap,
    ) => void;
    updateBaseInfo: (
      action: UpdateBaseInfoAction,
      effects: EffectsCommandMap,
    ) => void;
    updateStatus: (
      action: UpdateStatusAction,
      effects: EffectsCommandMap,
    ) => void;
    // updateRelation: (action: UpdateRelationAction, effects: EffectsCommandMap) => void;
    updateRewrite: (
      action: UpdateRewriteAction,
      effects: EffectsCommandMap,
    ) => void;
    changeVersion: (
      action: ChangeVersionAction,
      effects: EffectsCommandMap,
    ) => void;
    // updateContractUsed: (action: UpdateContractUsedAction, effects: EffectsCommandMap) => void;

    onSave_Side_ExhibitIntroduction: (
      action: OnSave_Side_ExhibitIntroduction_Action,
      effects: EffectsCommandMap,
    ) => void;
    onSync_Options: (
      action: OnSync_Options_Action,
      effects: EffectsCommandMap,
    ) => void;
  };
  reducers: {
    change: DvaReducer<CollectionExhibitInfoPageModelState, ChangeAction>;
  };
  subscriptions: {
    setup: Subscription;
  };
}

const initStates: CollectionExhibitInfoPageModelState = {
  pageLoading: true,

  exhibit_ID: '',
  exhibit_Name: '',
  exhibit_Title: '',
  exhibit_Online: false,
  exhibit_IsAuth: true,
  exhibit_AuthErrorText: '',
  exhibit_BelongNode_ID: -1,
  exhibit_BelongNode_Name: '',
  exhibit_BelongNode_Title: '',
  exhibit_BelongNode_ActiveThemeId: '',
  exhibit_Cover: '',
  exhibit_ResourceInfo: null,
  policy_List: [],

  graphShow: true,

  side_ExhibitTitle: '',
  side_ExhibitIntroduction: '',
  side_ExhibitTags: [],
  side_AllVersions: [],
  side_Version: '',
  side_SettingUnfold: false,
  side_RawProperties: [],
  side_BaseProperties: [],
  inheritOptions: [],
  customOptions: [],

  collectionItemsSetting: {
    collection_sort_list: 'collection_sort_ascending',
    collection_item_title: 'collection_item_title_rtitle',
    collection_item_no_display: 'collection_item_no_display_show',
    collection_item_image_display: 'collection_item_image_display_show',
    collection_item_descr_display: 'collection_item_descr_display_show',
    collection_view: 'collection_view_list',
  },
  collectionItems_keywords: '',
  collectionItems: [],
  collectionItems_totalCount: 0,
  collectionItems_pageCurrent: 1,
  collectionItems_pageSize: 10,
  collectionItems_inited: false,
};

const Model: CollectionExhibitInfoPageModelType = {
  namespace: 'collectionExhibitInfoPage',
  state: initStates,
  effects: {
    *onMountPage(
      { payload }: OnMountPageAction,
      { put, call }: EffectsCommandMap,
    ) {
      yield put<ChangeAction>({
        type: 'change',
        payload: {
          exhibit_ID: payload.exhibitID,
        },
      });

      yield put<FetchInfoAction>({
        type: 'fetchInfo',
      });
    },
    *onUnmountPage({}: OnUnmountPageAction, { put }: EffectsCommandMap) {
      yield put<ChangeAction>({
        type: 'change',
        payload: {
          ...initStates,
        },
      });
    },
    *fetchInfo({}: FetchInfoAction, { call, select, put }: EffectsCommandMap) {
      const { collectionExhibitInfoPage }: ConnectState = yield select(
        ({ collectionExhibitInfoPage }: ConnectState) => ({
          collectionExhibitInfoPage,
        }),
      );

      if (!collectionExhibitInfoPage.exhibit_ID) {
        return;
      }

      const params: Parameters<
        typeof FServiceAPI.Exhibit.presentableDetails
      >[0] = {
        presentableId: collectionExhibitInfoPage.exhibit_ID,
        isLoadCustomPropertyDescriptors: 1,
        isLoadPolicyInfo: 1,
        isTranslate: 1,
      };

      yield put<ChangeAction>({
        type: 'change',
        payload: {
          exhibit_ID: '',
        },
      });
      const {
        data: data_PresentableDetails,
      }: {
        data: {
          nodeId: number;
          userId: number;
          presentableId: string;
          presentableName: string;
          resourceInfo: any;
          resourceCustomPropertyDescriptors: {
            candidateItems: string[];
            defaultValue: string;
            key: string;
            name: string;
            remark: string;
            type: 'readonlyText' | 'select' | 'editableText';
          }[];
          coverImages: string[];
          onlineStatus: number;
          policies: any[];
          presentableTitle: string;
          presentableIntro: string;
          resolveResources: any[];
          tags: string[];
          version: string;
          resourceSystemProperty: {
            [k: string]: string;
          };
          resourceSystemPropertyDescriptors: {
            defaultValue: number | string;
            key: string;
            name: string;
            remark: string;
            valueDisplay: string;
            valueUnit: string;
          }[];
          presentableRewriteProperty: {
            key: string;
            remark: string;
            value: string;
          }[];
        };
      } = yield call(FServiceAPI.Exhibit.presentableDetails, params);
      if (
        !data_PresentableDetails ||
        data_PresentableDetails.userId !== FUtil.Tool.getUserIDByCookies()
      ) {
        history.replace(FUtil.LinkTo.exception403({}));
        return;
      }

      const params3: Parameters<typeof FServiceAPI.Node.details>[0] = {
        nodeId: data_PresentableDetails.nodeId,
      };

      const { data: data_NodeDetails } = yield call(
        FServiceAPI.Node.details,
        params3,
      );
      // console.log(data3, 'data90j23rlkfjasdfa');

      if ((data_NodeDetails.status & 4) === 4) {
        history.replace(
          FUtil.LinkTo.nodeFreeze({ nodeID: data_PresentableDetails.nodeId }),
        );
        return;
      }

      const params2: Parameters<typeof FServiceAPI.Resource.info>[0] = {
        resourceIdOrName: data_PresentableDetails.resourceInfo.resourceId,
      };

      const {
        data: data_ResourceInfo,
      }: {
        data: {
          resourceId: string;
          coverImages: string[];
          resourceName: string;
          resourceTitle: string;
          resourceTypeCode: string;
          resourceType: string[];
          updateDate: string;
          status: 0 | 1 | 2 | 4;
          latestVersion: string;
          resourceVersions: {
            version: string;
          }[];
          policies: PolicyFullInfo_Type[];
          // updateDate: string;
          username: string;
          userId: number;
          operationType: 0 | 1 | 2 | 3 | 4 | 5;
          subjectType: number;
          serializeStatus: number;
        };
      } = yield call(FServiceAPI.Resource.info, params2);

      // 要禁用的键
      const disabledRewriteKeys = [
        ...data_PresentableDetails.resourceCustomPropertyDescriptors.map(
          (i) => i.key,
        ),
      ];

      // 获取展品授权结果
      const params1: Parameters<typeof FServiceAPI.Exhibit.batchAuth>[0] = {
        nodeId: data_PresentableDetails.nodeId,
        authType: 3,
        presentableIds: data_PresentableDetails.presentableId,
      };
      const { data: data_ExhibitBatchAuthResults } = yield call(
        FServiceAPI.Exhibit.batchAuth,
        params1,
      );

      const policies: PolicyFullInfo_Type[] = [
        ...data_PresentableDetails.policies,
      ];
      policies.reverse();

      policies.sort((a, b) => {
        return a.status === 1 && b.status === 0 ? -1 : 0;
      });

      const param2: Parameters<
        typeof FServiceAPI.Resource.resourceVersionInfo1
      >[0] = {
        version: '1.0.0',
        resourceId: data_ResourceInfo.resourceId,
      };
      const {
        data: data_versionInfo,
      }: {
        data: {
          customPropertyDescriptors: {
            key: string;
            name: string;
            defaultValue: string;
            type:
              | 'editableText'
              | 'readonlyText'
              | 'radio'
              | 'checkbox'
              | 'select';
            candidateItems: string[];
            remark: string;
          }[];
          systemProperty: { [key: string]: string };
          systemPropertyDescriptors: {
            defaultValue: number | string;
            key: string;
            name: string;
            remark: string;
            valueDisplay: string;
            valueUnit: string;
          }[];
          createDate: string;
          description: string;
          catalogueProperty: {
            collection_item_count: number;
            // collection_sorting?: 'collection_sort_newest'
            //   | 'collection_sort_oldest'
            //   | 'collection_sort_title'
            //   | 'collection_sort_title_reverse'
            //   | 'collection_sort_manual'
            //   | 'collection_sort_manual_reverse',
            collection_sort_list?:
              | 'collection_sort_ascending'
              | 'collection_sort_descending';
            collection_item_title?:
              | 'collection_item_title_rtitle'
              | 'collection_item_title_sn'
              | 'collection_item_title_empty'
              | 'collection_item_title_custom';
            collection_item_no_display?:
              | 'collection_item_no_display_show'
              | 'collection_item_no_display_hide';
            collection_item_image_display?:
              | 'collection_item_image_display_show'
              | 'collection_item_image_display_hide';
            collection_item_descr_display?:
              | 'collection_item_descr_display_show'
              | 'collection_item_descr_display_hide';
            collection_view?: 'collection_view_list' | 'collection_view_card';
          };
        };
      } = yield call(FServiceAPI.Resource.resourceVersionInfo1, param2);

      yield put<ChangeAction>({
        type: 'change',
        payload: {
          pageLoading: false,
          exhibit_BelongNode_ID: data_PresentableDetails.nodeId,
          exhibit_BelongNode_Name: data_NodeDetails.nodeName,
          exhibit_BelongNode_Title: data_NodeDetails.nodeTitle,
          exhibit_BelongNode_ActiveThemeId: data_NodeDetails.nodeThemeId,
          exhibit_ID: data_PresentableDetails.presentableId,
          exhibit_Name: data_PresentableDetails.presentableName,
          exhibit_Title: data_PresentableDetails.presentableTitle,
          exhibit_Online: data_PresentableDetails.onlineStatus === 1,
          exhibit_IsAuth: data_ExhibitBatchAuthResults
            ? data_ExhibitBatchAuthResults[0].isAuth
            : true,
          exhibit_AuthErrorText: data_ExhibitBatchAuthResults
            ? data_ExhibitBatchAuthResults[0].error
            : '',
          exhibit_Cover: data_PresentableDetails.coverImages[0] || '',
          exhibit_ResourceInfo: {
            id: data_ResourceInfo.resourceId,
            cover: data_ResourceInfo.coverImages[0] || '',
            name: data_ResourceInfo.resourceName,
            title: data_ResourceInfo.resourceTitle,
            version: data_ResourceInfo.latestVersion,
            policy: data_ResourceInfo.policies
              .filter((l) => {
                return l.status === 1;
              })
              .map((l) => l.policyName),
            type: data_ResourceInfo.resourceType,
            status: data_ResourceInfo.status,
            authProblem: false,
            updateDate: moment(data_ResourceInfo.updateDate).format(
              'YYYY-MM-DD',
            ),
            username: data_ResourceInfo.username,
            useAvatar: `https://image.freelog.com/avatar/${data_ResourceInfo.userId}`,
            isChoice: data_ResourceInfo.operationType === 5,
            collection:
              data_ResourceInfo.subjectType === 4
                ? {
                    status:
                      data_ResourceInfo.serializeStatus === 1
                        ? 'finish'
                        : 'unFinish',
                    count:
                      data_versionInfo.catalogueProperty.collection_item_count,
                  }
                : null,
          },

          policy_List: policies,

          side_ExhibitTitle: data_PresentableDetails.presentableTitle,
          side_ExhibitIntroduction:
            data_PresentableDetails.presentableIntro || '',
          side_ExhibitTags: data_PresentableDetails.tags,

          side_AllVersions: data_ResourceInfo.resourceVersions.map(
            (d2: any) => d2.version,
          ),
          side_Version: data_PresentableDetails.version,
          side_RawProperties:
            data_PresentableDetails.resourceSystemPropertyDescriptors
              .filter((spd) => {
                return spd.defaultValue !== '';
              })
              .map((spd) => {
                return {
                  key: spd.key,
                  name: spd.name,
                  value: spd.valueDisplay,
                  description: spd.remark,
                };
              }),
          side_BaseProperties:
            data_PresentableDetails.resourceCustomPropertyDescriptors
              .filter((rd) => {
                return rd.type === 'readonlyText' && rd.defaultValue !== '';
              })
              .map((rd: any) => ({
                key: rd.key,
                name: rd.name,
                value: rd.defaultValue,
                description: rd.remark,
              })),
          inheritOptions:
            data_PresentableDetails.resourceCustomPropertyDescriptors
              .filter((rd) => {
                return rd.type === 'editableText' || rd.type === 'select';
              })
              .map<
                CollectionExhibitInfoPageModelState['inheritOptions'][number]
              >((rd) => {
                const prp =
                  data_PresentableDetails.presentableRewriteProperty.find(
                    (pr) => pr.key === rd.key,
                  );
                const value = prp ? prp.value : rd.defaultValue;
                return {
                  key: rd?.key || '',
                  name: rd?.name || '',
                  value: value,
                  description: rd.remark || '',
                  type: rd.type === 'select' ? 'select' : 'input',
                  options: rd.type === 'select' ? rd.candidateItems : [],
                  defaultValue: rd.defaultValue || '',
                };
              }),
          customOptions: (
            data_PresentableDetails.presentableRewriteProperty as any[]
          )
            .filter((pr: any) => !disabledRewriteKeys.includes(pr.key))
            .map<CollectionExhibitInfoPageModelState['customOptions'][number]>(
              (pr) => {
                return {
                  key: pr.key,
                  name: pr.name,
                  value: pr.value,
                  description: pr.remark,
                  valueInput: pr.value,
                  valueInputError: '',
                };
              },
            ),

          collectionItemsSetting: {
            // collection_sorting: data_versionInfo.catalogueProperty.collection_sorting || 'collection_sort_newest',
            collection_sort_list:
              data_versionInfo.catalogueProperty.collection_sort_list ||
              'collection_sort_ascending',
            collection_item_title:
              data_versionInfo.catalogueProperty.collection_item_title ||
              'collection_item_title_rtitle',
            collection_item_no_display:
              data_versionInfo.catalogueProperty.collection_item_no_display ||
              'collection_item_no_display_show',
            collection_item_image_display:
              data_versionInfo.catalogueProperty
                .collection_item_image_display ||
              'collection_item_image_display_show',
            collection_item_descr_display:
              data_versionInfo.catalogueProperty
                .collection_item_descr_display ||
              'collection_item_descr_display_show',
            collection_view:
              data_versionInfo.catalogueProperty.collection_view ||
              'collection_view_list',
          },
          collectionItems_pageSize:
            data_versionInfo.catalogueProperty.collection_view ===
            'collection_view_card'
              ? 6
              : 10,
        },
      });

      yield put<Fetch_CollectionItems_Action>({
        type: 'fetch_CollectionItems',
      });
    },
    *fetch_CollectionItems(
      {}: Fetch_CollectionItems_Action,
      { select, call, put }: EffectsCommandMap,
    ) {
      const { collectionExhibitInfoPage }: ConnectState = yield select(
        ({ collectionExhibitInfoPage }: ConnectState) => ({
          collectionExhibitInfoPage,
        }),
      );

      let data_collectionItems: {
        createDate: string;
        itemId: string;
        itemTitle: string;
        sortId: number;
        number: string;
        mountResourceInfo: {
          resourceId: string;
        };
      }[] = [];

      const parmas: Parameters<
        typeof FServiceAPI.Resource.getCollectionItems
      >[0] = {
        resourceId: collectionExhibitInfoPage.exhibit_ResourceInfo?.id || '',
        skip:
          (collectionExhibitInfoPage.collectionItems_pageCurrent - 1) *
          collectionExhibitInfoPage.collectionItems_pageSize,
        limit: collectionExhibitInfoPage.collectionItems_pageSize,
        sortType:
          collectionExhibitInfoPage.collectionItemsSetting
            .collection_sort_list === 'collection_sort_descending'
            ? -1
            : 1,
        isLoadLatestVersionInfo: 1,
      };

      const {
        ret,
        errCode,
        data,
      }: {
        ret: number;
        errCode: number;
        data: {
          skip: number;
          limit: number;
          totalItem: number;
          dataList: {
            createDate: string;
            itemId: string;
            itemTitle: string;
            sortId: number;
            number: string;
            mountResourceInfo: {
              resourceId: string;
            };
          }[];
        };
      } = yield call(FServiceAPI.Resource.getCollectionItems, parmas);

      if (data.dataList.length > 0) {
        data_collectionItems = data.dataList;
      } else if (collectionExhibitInfoPage.collectionItems_pageCurrent > 1) {
        yield put<ChangeAction>({
          type: 'change',
          payload: {
            collectionItems_pageCurrent: 1,
          },
        });

        const parmas: Parameters<
          typeof FServiceAPI.Resource.getCollectionItems
        >[0] = {
          resourceId: collectionExhibitInfoPage.exhibit_ResourceInfo?.id || '',
          skip:
            (collectionExhibitInfoPage.collectionItems_pageCurrent - 1) *
            collectionExhibitInfoPage.collectionItems_pageSize,
          limit: collectionExhibitInfoPage.collectionItems_pageSize,
          keywords: collectionExhibitInfoPage.collectionItems_keywords,
          isLoadLatestVersionInfo: 1,
        };

        const {
          ret,
          errCode,
          data: data1,
        }: {
          ret: number;
          errCode: number;
          data: {
            skip: number;
            limit: number;
            totalItem: number;
            dataList: {
              createDate: string;
              itemId: string;
              itemTitle: string;
              sortId: number;
              number: string;
              mountResourceInfo: {
                resourceId: string;
              };
            }[];
          };
        } = yield call(FServiceAPI.Resource.getCollectionItems, parmas);

        data_collectionItems = data1.dataList;
      }

      // console.log(data_collectionItems, 'DDDDDDDDDDDDDDDDDDDDDDDDDDDDD sdi8ojflskdjflkjlk');

      let data_resourceList: any[] = [];
      let auths: {
        itemId: string;
        isAuth: boolean;
      }[] = [];

      if (data_collectionItems.length > 0) {
        const { data: data_resourceList1 } = yield call(
          FServiceAPI.Resource.batchInfo,
          {
            resourceIds: data_collectionItems
              .map((d) => {
                return d.mountResourceInfo.resourceId;
              })
              .join(','),
          },
        );
        data_resourceList = data_resourceList1;

        const parmas1: Parameters<
          typeof FServiceAPI.Resource.getCollectionItemsAuth
        >[0] = {
          resourceId: collectionExhibitInfoPage.exhibit_ResourceInfo?.id || '',
          itemIds: data_collectionItems
            .map((d) => {
              return d.itemId;
            })
            .join(','),
        };
        const {
          data: data1,
        }: {
          data: {
            itemId: string;
            isAuth: boolean;
          }[];
        } = yield call(FServiceAPI.Resource.getCollectionItemsAuth, parmas1);
        // console.log(data1, '********************************* sdoifjsadlkfjlkj');
        auths = data1;
      }

      const list: CollectionDetailPageModelState['collectionItems'] =
        data_collectionItems.map<
          CollectionDetailPageModelState['collectionItems'][number]
        >((i, j: number) => {
          const resAuth = auths.find((dd) => {
            return dd.itemId === i.itemId;
          });

          const resource = data_resourceList.find((r) => {
            return r.resourceId === i.mountResourceInfo.resourceId;
          });
          // console.log(data_collectionItems[j], ' data.dataList[j] sdfsdfdsfsdf');
          return {
            itemID: i.itemId,
            itemTitle: i.itemTitle,
            itemSerial: i.sortId,
            itemNumber: i.number,
            resourceInfo: {
              id: resource.resourceId,
              cover:
                resource.coverImages.length > 0 ? resource.coverImages[0] : '',
              name: resource.resourceName,
              title: resource.resourceTitle,
              version: resource.latestVersion,
              policy: resource.policies
                .filter((l: any) => {
                  return l.status === 1;
                })
                .map((l: any) => l.policyName),
              type: resource.resourceType,
              status: resource.status,
              authProblem: !!resAuth && !resAuth.isAuth,
              updateDate: moment(resource.updateDate).format('YYYY-MM-DD'),
              username: resource.username,
              useAvatar: `https://image.freelog.com/avatar/${resource.userId}`,
              isChoice: resource.operationType === 5,
              intro: resource.intro,
              releaseDateTime: moment(
                resource.resourceVersions[0]?.createDate,
              ).format('YYYY-MM-DD'),
            },
          };
        });

      yield put<ChangeAction>({
        type: 'change',
        payload: {
          collectionItems: list,
          collectionItems_inited: true,
          collectionItems_totalCount: data.totalItem,
        },
      });
    },
    *addAPolicy(
      { payload }: AddAPolicyAction,
      { call, select, put }: EffectsCommandMap,
    ) {
      const { collectionExhibitInfoPage }: ConnectState = yield select(
        ({ collectionExhibitInfoPage }: ConnectState) => ({
          collectionExhibitInfoPage,
        }),
      );

      const params: Parameters<
        typeof FServiceAPI.Exhibit.updatePresentable
      >[0] = {
        presentableId: collectionExhibitInfoPage.exhibit_ID,
        addPolicies: [
          {
            policyName: payload.title,
            policyText: payload.text,
            status: 1,
          },
        ],
      };
      const res: {
        ret: number;
        errCode: number;
        msg: string;
      } = yield call(FServiceAPI.Exhibit.updatePresentable, params);

      if (res.ret !== 0 || res.errCode !== 0) {
        fMessage(res.msg, 'error');
        return;
      }

      fSetHotspotTooltipVisible('exhibitDetailPage.onlineSwitch', {
        value: true,
        effectiveImmediately: true,
        onlyNullish: true,
      });

      setTimeout(() => {
        fSetHotspotTooltipVisible('exhibitDetailPage.onlineSwitch', {
          value: false,
          effectiveImmediately: false,
          onlyNullish: false,
        });
      });

      if (
        !collectionExhibitInfoPage.exhibit_Online &&
        !collectionExhibitInfoPage.exhibit_ResourceInfo?.type.includes('主题')
      ) {
        const online: boolean = yield call(fPromiseModalConfirm, {
          title: '展品待上架',
          description: '将展品上架开放授权，为你带来更多收益',
          okText: '立即上架',
          cancelText: '暂不上架',
        });

        if (online) {
          const params2: Parameters<
            typeof FServiceAPI.Exhibit.presentablesOnlineStatus
          >[0] = {
            presentableId: collectionExhibitInfoPage.exhibit_ID,
            onlineStatus: 1,
          };
          yield call(FServiceAPI.Exhibit.presentablesOnlineStatus, params2);
          fSetHotspotTooltipVisible('exhibitDetailPage.onlineSwitch', {
            value: false,
            effectiveImmediately: true,
            onlyNullish: false,
          });
        }
      }

      const params1: Parameters<
        typeof FServiceAPI.Exhibit.presentableDetails
      >[0] = {
        presentableId: collectionExhibitInfoPage.exhibit_ID,
        isLoadCustomPropertyDescriptors: 1,
        isLoadPolicyInfo: 1,
        isTranslate: 1,
      };

      const { data: data_PresentableDetails } = yield call(
        FServiceAPI.Exhibit.presentableDetails,
        params1,
      );

      const policies: PolicyFullInfo_Type[] = [
        ...data_PresentableDetails.policies,
      ];
      policies.reverse();

      policies.sort((a, b) => {
        return a.status === 1 && b.status === 0 ? -1 : 0;
      });

      yield put<ChangeAction>({
        type: 'change',
        payload: {
          policy_List: policies,
          exhibit_Online: data_PresentableDetails.onlineStatus === 1,
        },
      });
    },
    *updateAPolicy(
      { payload }: UpdateAPolicyAction,
      { call, select, put }: EffectsCommandMap,
    ) {
      const { collectionExhibitInfoPage }: ConnectState = yield select(
        ({ collectionExhibitInfoPage }: ConnectState) => ({
          collectionExhibitInfoPage,
        }),
      );
      const params: Parameters<
        typeof FServiceAPI.Exhibit.updatePresentable
      >[0] = {
        presentableId: collectionExhibitInfoPage.exhibit_ID,
        updatePolicies: [
          {
            policyId: payload.id,
            status: payload.status,
          },
        ],
      };
      yield call(FServiceAPI.Exhibit.updatePresentable, params);
      // yield put<FetchInfoAction>({
      //   type: 'fetchInfo',
      // });

      const params1: Parameters<
        typeof FServiceAPI.Exhibit.presentableDetails
      >[0] = {
        presentableId: collectionExhibitInfoPage.exhibit_ID,
        isLoadCustomPropertyDescriptors: 1,
        isLoadPolicyInfo: 1,
        isTranslate: 1,
      };

      const { data: data_PresentableDetails } = yield call(
        FServiceAPI.Exhibit.presentableDetails,
        params1,
      );

      const policies: PolicyFullInfo_Type[] = [
        ...data_PresentableDetails.policies,
      ];
      policies.reverse();

      policies.sort((a, b) => {
        return a.status === 1 && b.status === 0 ? -1 : 0;
      });

      yield put<ChangeAction>({
        type: 'change',
        payload: {
          policy_List: policies,
        },
      });
    },
    *updateBaseInfo(
      { payload }: UpdateBaseInfoAction,
      { select, call, put }: EffectsCommandMap,
    ) {
      const { collectionExhibitInfoPage }: ConnectState = yield select(
        ({ collectionExhibitInfoPage }: ConnectState) => ({
          collectionExhibitInfoPage,
        }),
      );

      const params: Parameters<
        typeof FServiceAPI.Exhibit.updatePresentable
      >[0] = {
        presentableId: collectionExhibitInfoPage.exhibit_ID,
        presentableTitle: payload.side_ExhibitTitle,
        tags: payload.side_ExhibitTags,
        // @ts-ignore
        presentableIntro: payload.side_ExhibitInputIntroduction || undefined,
        coverImages: payload.exhibit_Cover
          ? [payload.exhibit_Cover]
          : undefined,
      };
      const { ret, errCode, msg } = yield call(
        FServiceAPI.Exhibit.updatePresentable,
        params,
      );
      if (ret !== 0 || errCode !== 0) {
        fMessage(msg, 'error');
        return;
      }
      yield put<ChangeAction>({
        type: 'change',
        payload,
      });
    },
    *updateStatus(
      { payload }: UpdateStatusAction,
      { call, select, put }: EffectsCommandMap,
    ) {
      const { collectionExhibitInfoPage }: ConnectState = yield select(
        ({ collectionExhibitInfoPage }: ConnectState) => ({
          collectionExhibitInfoPage,
        }),
      );
      const params: Parameters<
        typeof FServiceAPI.Exhibit.presentablesOnlineStatus
      >[0] = {
        presentableId: collectionExhibitInfoPage.exhibit_ID,
        onlineStatus: payload,
      };
      const { data } = yield call(
        FServiceAPI.Exhibit.presentablesOnlineStatus,
        params,
      );
      if (!data) {
        fMessage(
          collectionExhibitInfoPage.exhibit_ResourceInfo?.type.includes('主题')
            ? '激活失败'
            : '上线失败',
          'error',
        );
        return;
      }
      yield put<FetchInfoAction>({
        type: 'fetchInfo',
      });
    },

    // * updateRelation({ payload }: UpdateRelationAction, { select, call, put }: EffectsCommandMap) {
    //   const { collectionExhibitInfoPage }: ConnectState = yield select(({ collectionExhibitInfoPage }: ConnectState) => ({
    //     collectionExhibitInfoPage,
    //   }));
    //
    //   // const resource = collectionExhibitInfoPage.contract_Associated.find((a) => a.id === payload.resourceId);
    //   // console.log(resource, '$#@$#$@#');
    //
    //   const params1: HandleFinalResolveResourceParams = {
    //     exhibitID: collectionExhibitInfoPage.exhibit_ID,
    //     resourceID: payload.resourceId,
    //     policyID: payload.policyId,
    //     isUsed: true,
    //   };
    //
    //   const resolveResources: HandleFinalResolveResourceReturn = yield call(handleFinalResolveResource, params1);
    //
    //   const params: Parameters<typeof FServiceAPI.Exhibit.updatePresentable>[0] = {
    //     presentableId: collectionExhibitInfoPage.exhibit_ID,
    //     resolveResources: resolveResources,
    //   };
    //
    //   // console.log(params, 'params2093uiksdjflsdkjl');
    //   const { data, ret, errCode, msg } = yield call(FServiceAPI.Exhibit.updatePresentable, params);
    //   if (ret !== 0 || errCode !== 0) {
    //     fMessage(msg, 'error');
    //     return;
    //   }
    //   yield put<FetchInfoAction>({
    //     type: 'fetchInfo',
    //   });
    // },
    *updateRewrite(
      {}: UpdateRewriteAction,
      { select, call, put }: EffectsCommandMap,
    ) {
      const { collectionExhibitInfoPage }: ConnectState = yield select(
        ({ collectionExhibitInfoPage }: ConnectState) => ({
          collectionExhibitInfoPage,
        }),
      );

      const params: Parameters<
        typeof FServiceAPI.Exhibit.updateRewriteProperty
      >[0] = {
        presentableId: collectionExhibitInfoPage.exhibit_ID,
        rewriteProperty: [
          ...collectionExhibitInfoPage.inheritOptions.map((io) => {
            return {
              key: io.key,
              value: io.value,
              remark: io.description,
            };
          }),
          ...collectionExhibitInfoPage.customOptions.map((io) => {
            return {
              key: io.key,
              value: io.value,
              remark: io.description,
            };
          }),
        ],
      };
      yield call(FServiceAPI.Exhibit.updateRewriteProperty, params);
    },
    *changeVersion(
      { payload }: ChangeVersionAction,
      { call, put, select }: EffectsCommandMap,
    ) {
      const { collectionExhibitInfoPage }: ConnectState = yield select(
        ({ collectionExhibitInfoPage }: ConnectState) => ({
          collectionExhibitInfoPage,
        }),
      );
      const params: Parameters<
        typeof FServiceAPI.Exhibit.presentablesVersion
      >[0] = {
        presentableId: collectionExhibitInfoPage.exhibit_ID,
        version: payload,
      };
      yield call(FServiceAPI.Exhibit.presentablesVersion, params);
      yield put<FetchInfoAction>({
        type: 'fetchInfo',
      });
    },
    // * updateContractUsed({ payload }: UpdateContractUsedAction, { select, call, put }: EffectsCommandMap) {

    // const { collectionExhibitInfoPage }: ConnectState = yield select(({ collectionExhibitInfoPage }: ConnectState) => ({
    //   collectionExhibitInfoPage,
    // }));

    // console.log(data, 'data123412398yuoihjkl');

    // const params3: HandleFinalResolveResourceParams = payload;

    // const resolveResources: HandleFinalResolveResourceReturn = yield call(handleFinalResolveResource, params3);

    // const params2: Parameters<typeof FServiceAPI.Exhibit.updatePresentable>[0] = {
    //   presentableId: payload.exhibitID,
    //   resolveResources: resolveResources,
    // };
    // console.log(params2, 'params2!@!@#$@!#$!@#$');

    // console.log(params2, 'params2234234234234');

    // const { data: data2 } = yield call(FServiceAPI.Exhibit.updatePresentable, params2);

    // 根据资源 id 批量查询所有合同
    // const params5: Parameters<typeof FServiceAPI.Exhibit.presentableList>[0] = {
    //   nodeId: collectionExhibitInfoPage.exhibit_BelongNode_ID,
    //
    //   resolveResourceIds: collectionExhibitInfoPage.contract_Associated.map((rs) => {
    //     return rs.id;
    //   }).join(','),
    // };

    // const { data: data5 } = yield call(FServiceAPI.Exhibit.presentableList, params5);

    // const exhibitAllContractIDs: {
    //   exhibitID: string;
    //   resourceID: string;
    //   contractIDs: string[];
    // }[] = data5.map((d5: any) => {
    //   return d5.resolveResources?.map((resvr: any) => {
    //     return {
    //       exhibitID: d5.presentableId,
    //       resourceID: resvr.resourceId,
    //       contractIDs: resvr.contracts.map((cccc: any) => {
    //         return cccc.contractId;
    //       }),
    //     };
    //   });
    // }).flat();

    // yield put<ChangeAction>({
    //   type: 'change',
    //   payload: {
    //     contract_ExhibitAllContractIDs: exhibitAllContractIDs,
    //   },
    // });
    // },
    *onSave_Side_ExhibitIntroduction(
      { payload }: OnSave_Side_ExhibitIntroduction_Action,
      { select, call, put }: EffectsCommandMap,
    ) {
      const { collectionExhibitInfoPage }: ConnectState = yield select(
        ({ collectionExhibitInfoPage }: ConnectState) => ({
          collectionExhibitInfoPage,
        }),
      );
      const oldText: string =
        collectionExhibitInfoPage.side_ExhibitIntroduction;
      yield put<ChangeAction>({
        type: 'change',
        payload: {
          side_ExhibitIntroduction: payload.value,
        },
      });

      const params: Parameters<
        typeof FServiceAPI.Exhibit.updatePresentable
      >[0] = {
        presentableId: collectionExhibitInfoPage.exhibit_ID,
        presentableIntro: payload.value,
      };
      const { ret, errCode, msg } = yield call(
        FServiceAPI.Exhibit.updatePresentable,
        params,
      );
      if (ret !== 0 || errCode !== 0) {
        fMessage(msg, 'error');
        yield put<ChangeAction>({
          type: 'change',
          payload: {
            side_ExhibitIntroduction: oldText,
          },
        });
        return;
      }
    },
    *onSync_Options(
      { payload }: OnSync_Options_Action,
      { select, call, put }: EffectsCommandMap,
    ) {
      const { collectionExhibitInfoPage }: ConnectState = yield select(
        ({ collectionExhibitInfoPage }: ConnectState) => ({
          collectionExhibitInfoPage,
        }),
      );

      const params: UpdateRewriteParams = {
        exhibit_ID: collectionExhibitInfoPage.exhibit_ID,
        inheritOptions: collectionExhibitInfoPage.inheritOptions,
        customOptions: collectionExhibitInfoPage.customOptions,
      };
      const {
        data,
        errCode,
        ret,
        msg,
      }: {
        data: boolean;
        errCode: number;
        msg: string;
        ret: number;
      } = yield call(updateRewrite, params);
      if (ret !== 0 || errCode !== 0 || !data) {
        return fMessage(msg, 'error');
      }
      if (payload?.successMessage) {
        fMessage(payload?.successMessage);
      }
    },
  },
  reducers: {
    change(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
  subscriptions: {
    setup({}) {},
  },
};

export default Model;

/**
 * 组织授权信息数据
 */
export type HandleRelationParams = {
  contracts: {
    contractId: string;
    policyId: string;
  }[];
  resourceId: string;
  resourceName: string;
}[];

export type HandleRelationResult = {
  resourceId: string;
  resourceName: string;
  resourceType: string[];
  status: 0 | 1 | 2 | 4;
  contracts: {
    contractId: string;
    contractName: string;
    createDate: string;
    policyText: string;
    status: 'active' | 'testActive' | 'inactive' | 'terminal';
    policyId: string;
  }[];
  terminatedContractIDs: string[];
  policies: PolicyFullInfo_Type[];
}[];

export async function handleRelation(
  params: HandleRelationParams,
  nodeID: number,
): Promise<HandleRelationResult> {
  const resourceIds: string[] = params.map((r) => r.resourceId);

  const allContracts = await getAllContracts({
    nodeID,
    resourceIDs: resourceIds,
  });

  const params0: Parameters<typeof FServiceAPI.Resource.batchInfo>[0] = {
    resourceIds: resourceIds.join(','),
    isLoadPolicyInfo: 1,
    isTranslate: 1,
  };

  const { data: data0 }: any = await FServiceAPI.Resource.batchInfo(params0);
  // console.log(data0, data1, 'data0, data123rfsda');

  const result: HandleRelationResult = params.map((r) => {
    const resource = data0.find((dr: any) => dr.resourceId === r.resourceId);
    // console.log(resource, 'resource4329203ujlkzfsd');
    const contracts: HandleRelationResult[number]['contracts'] = allContracts
      .filter((acts: any) => {
        return acts.licensorId === resource.resourceId && acts.status === 0;
      })
      .map((contract: any) => {
        // console.log(contract, 'contract0923');
        return {
          contractId: contract.contractId,
          contractName: contract.contractName,
          createDate: contract.createDate,
          policyText: contract.policyInfo.policyText,
          status:
            contract.status === 1
              ? 'terminal'
              : contract.authStatus === 1 || contract.authStatus === 3
              ? 'active'
              : contract.authStatus === 2
              ? 'testActive'
              : 'inactive',
          policyId: contract.policyId,
        };
      });
    const allContractsUsedPolicyIDs: string[] = contracts.map<string>((c) => {
      return c.policyId;
    });
    // console.log(allContractsUsedPolicyIDs, 'allContractsUsedPolicyIDsallContractsUsedPolicyIDs0932o');
    return {
      resourceId: resource.resourceId,
      resourceName: resource.resourceName,
      resourceType: resource.resourceType,
      status: resource.status,
      contracts: contracts,
      terminatedContractIDs: allContracts
        .filter((acts: any) => {
          return acts.licensorId === resource.resourceId && acts.status === 1;
        })
        .map((acts: any) => {
          return acts.contractId;
        }),
      policies: resource.policies
        // .filter((p: any) => {
        //   return !allContracts
        //     .some((act: any) => {
        //       // console.log(p, act, '!@#$!@#$!@#$!@#$!@#$!@#$!@#$');
        //       return act.licensorId === resource.resourceId && act.policyId === p.policyId;
        //     });
        // })
        .filter((p: any) => {
          // console.log(p, 'PPPpppPPPPppPPPPpppPPP');
          return (
            p.status === 1 && !allContractsUsedPolicyIDs.includes(p.policyId)
          );
        }),
    };
  });
  // console.log(result, 'result2309jd');
  return result;
}

interface GetAllContractsParamsType {
  nodeID: number;
  resourceIDs: string[];
}

type GetAllContractsReturnType = {
  contractId: string;
  contractName: string;
  createDate: string;
  updateDate: string;
  policyId: string;
  policyInfo: {
    policyId: string;
    policyText: string;
  };
}[];

export async function getAllContracts({
  nodeID,
  resourceIDs,
}: GetAllContractsParamsType): Promise<GetAllContractsReturnType> {
  // console.log(resourceIDs, 'resourceIDs!!@#$!@#$!@$1230900000000');
  const allPromises = resourceIDs.map(async (id) => {
    const params: Parameters<typeof FServiceAPI.Contract.batchContracts>[0] = {
      licensorId: id,
      licenseeId: nodeID,
      licenseeIdentityType: 2,
      isLoadPolicyInfo: 1,
      subjectIds: id,
      subjectType: 1,
    };
    const { data } = await FServiceAPI.Contract.batchContracts(params);
    // console.log(data, 'data!!!1111100000000))))))');
    return data;
  });

  return (await Promise.all(allPromises)).flat();
}
